import React from 'react';

import cn from 'classnames';
import { useTranslation, useResponsive } from 'client/hooks';
import { thousandSeparator } from 'utils/thousand-separator';

import Icon from '../../../Icon';

import css from './ListenersDetailsDrawerButton.module.scss';

interface Props {
  counter: number;
  isListenersDetailsDrawerOpen: boolean;
}

const ListenersDetailsDrawerButton: React.FC<Props> = (props) => {
  const { counter, isListenersDetailsDrawerOpen } = props;
  const { translate } = useTranslation('actionsPanel');
  const [isMobile] = useResponsive('MOBILE');

  return (
    <>
      <div className={cn(css.iconWrapper, isListenersDetailsDrawerOpen && css.active)}>
        <Icon type="participants" className={css.icon} />
      </div>
      <div className={css.name}>
        {translate('btns.usersStatisticBtn')}&nbsp;
        {!isMobile && counter > 0 && <>({thousandSeparator(counter)})</>}
      </div>
      {isMobile && counter > 0 && <div className={css.totalListenersCounter}>({counter})</div>}
    </>
  );
};

export default ListenersDetailsDrawerButton;
